import KiosksLiveUsageReduxState, {
  KioskLiveUsagePayloadData,
  KioskLiveUsagePayloadEvent,
} from '../@types/KiosksLiveUsageReduxState';

import { isEqual } from 'lodash';

export default function setKioskLiveUsageAction(
  currentState: KiosksLiveUsageReduxState,
  actionPayload: KioskLiveUsagePayloadEvent
): KiosksLiveUsageReduxState {
  const kioskInfoAlreadySet = currentState[actionPayload.kioskId];
  if (kioskInfoAlreadySet) {
    const kioskInfoAlreadySetPayload: KioskLiveUsagePayloadEvent = {
      accessGrantId: kioskInfoAlreadySet.payload.accessGrant?.id,
      kioskId: kioskInfoAlreadySet.payload.kioskId,
    };
    if (isEqual(kioskInfoAlreadySetPayload, actionPayload)) {
      throw new Error('Kiosk info already set');
    }
  }

  const newKioskPayload: KioskLiveUsagePayloadData = {
    accessGrant: actionPayload.accessGrantId
      ? {
          id: actionPayload.accessGrantId,
        }
      : undefined,
    kioskId: actionPayload.kioskId,
  };

  return {
    ...currentState,
    [actionPayload.kioskId]: { payload: newKioskPayload },
  };
}
